import {
    ADDRESS_VALIDATION_CODES,
    type AddressSuggestionError,
    type AddressValidatorError,
    type AddressValidatorFailureResult,
    type AddressValidatorResult,
    type AddressValidatorSuccessResult,
    type MissingHouseNumberError,
} from "./types";

export const isFailureAddressValidatorResult = (
    result: AddressValidatorResult
): result is AddressValidatorFailureResult => {
    return !result.isValid;
};

export const isSuccessAddressValidatorResult = (
    result: AddressValidatorResult
): result is AddressValidatorSuccessResult => {
    return result.isValid;
};

export const isSuggestionError = (
    error: AddressValidatorError
): error is AddressSuggestionError => {
    return error.type === ADDRESS_VALIDATION_CODES.ADDRESS_SUGGESTION;
};

export const isMissingHouseNumberError = (
    error: AddressValidatorError
): error is MissingHouseNumberError => {
    return error.type === ADDRESS_VALIDATION_CODES.MISSING_HOUSE_NUMBER;
};
